import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Ellipsis, FileText, ReceiptText, Settings2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import classNames from "classnames";
import { get } from "lodash";

import useAlert from "hooks/useAlert";
import useTranslation from "hooks/useTranslation";
import EntityForm from "modules/entity/forms";
import ModulesActions from "modules/entity/actions";
import { Modal as CustomModal } from "components";
import { Modal } from "components/index";
import DeleteReports from "./DeleteReporst";
import ImportModal from './importModal'
import BasicData from "./components/basicData";
import BasicSettings from "./components/basicSettings";
import ChequeSettings from "./components/chequeSettings";
import OtherSettings from "./components/otherSetings";
import TaxParameters from "./components/taxParameters";
import TelegramSettings from "./components/telegramSettings";

import QuestionCircle from "assets/images/icons/question-circle.svg";
import TaxIcon from "assets/images/icons/tax.png";
import TelegramIcon from "assets/images/icons/telegram.svg";

const settingsMenuKey = {
  main_data_settings: "main_data_settings",
  main_settings: "main_settings",
  receipt_settings: "receipt_settings",
  online_menu_settings: "online_menu_settings",
  other_settings: "other_settings",
  sales: "sales",
  profile: "profile",
  cheque_constructor: "cheque_constructor",
  old_version: "old_version",
  tax: "tax",
  telegram: "telegram",
};

const menuItems = [
  {
    id: "main_data_settings",
    label: "Основные данные",
    icon: <FileText />
  },
  {
    id: "main_settings",
    label: "Основные настройки",
    icon: <Settings2 />
  },
  // {
  //   id: "cheque_settings",
  //   label: "Настройки для чека",
  //   icon: <ReceiptText />
  // },
  {
    id: "other_settings",
    label: "Другие настройки",
    icon: <Ellipsis />
  },
  // {
  //   id: "tax_parameters",
  //   label: "Налоговые параметры",
  //   icon: <img src={TaxIcon} alt="" className="w-[34px] h-[34px] ml-[-5px]" />
  // },
  {
    id: "telegram_settings",
    label: "Настройки Telegram",
    icon: <img src={TelegramIcon} alt="" className="w-[28px] h-[28px]" />
  }
];

export const NewSettings = () => {
  const { tr } = useTranslation();
  const { showAlert } = useAlert();
  const dispatch = useDispatch();
  const { selectedOrganization } = useSelector(store => ({
    selectedOrganization: store.auth.selected_organization
  }));

  const [activeSettingsMenu, setActiveSettingsMenu] = useState(
    sessionStorage.getItem("activeSettingsMenu") ||
    settingsMenuKey.main_data_settings
  );

  useEffect(() => {
    if (
      activeSettingsMenu !== settingsMenuKey.cheque_constructor &&
      activeSettingsMenu !== settingsMenuKey.old_version
    )
      sessionStorage.setItem("activeSettingsMenu", activeSettingsMenu);
  }, [activeSettingsMenu]);

  const profile = useSelector(state => state.auth.user);
  const [password, setPassword] = useState("");
  const [removeModal, showRemoveModal] = useState(false);
  const [clearDataModal, showClearDataModal] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [importModal, showImportModal] = useState(false);

  const removeAction = () => {
    setSubmitting(true);
    dispatch(
      ModulesActions.FormDefault.request({
        method: "post",
        url: `/user/organization/${profile.organization_id}/clear-storage`,
        values: {
          phone: profile.phone,
          password: password
        },
        cb: {
          success: () => {
            showAlert(tr("Успешно удалено"), { type: "success" });
            window.location.reload();
          },
          error: response => {
            const errorMessage = get(response, "errorMessage", "");
            showAlert(errorMessage, { type: "danger" });
          },
          finally: () => {
            setSubmitting(false);
          }
        }
      })
    );
  };

  return (
    <>
      <>
        <div className="grid grid-cols-12 relative bg-white">
          <div className="col-span-3 relative">
            <div
              className="!border-gray-200 space-y-3 p-3 !sticky !top-24"
              style={{ borderRight: "1px solid" }}
            >
              {menuItems.map((menu) => {
                return (
                  <div
                    onClick={() => setActiveSettingsMenu(menu.id)}
                    key={menu.id}
                    className={classNames({
                      "flex items-center hover:bg-[#EFF4FF] gap-3 cursor-pointer duration-100 border-lg h-14 !pl-5 rounded-xl": true,
                      "bg-[#EFF4FF] text-primary font-bold":
                        menu.id === activeSettingsMenu
                    })}
                  >
                    {menu.icon}
                    <p className="my-0">{tr(menu.label)}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-span-9">
            <EntityForm.Default
              method="put"
              url={`/user/organization/${selectedOrganization.id}`}
              onSuccess={data => {
                showAlert(tr("Успешно сохранено"), { type: "success" });
                window.location.reload();
              }}
              onError={error => {
                const errorMessage = get(error, "errorData.errorMessage");
                showAlert(errorMessage, { type: "danger", delay: 5000 });
              }}
              fields={[
                {
                  name: "has_on_table",
                  value:
                    get(selectedOrganization, "setting.has_on_table") === 1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "has_takeaway",
                  value:
                    get(selectedOrganization, "setting.has_takeaway") === 1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "has_delivery",
                  value:
                    get(selectedOrganization, "setting.has_delivery") === 1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "has_telegram_bot",
                  value:
                    get(selectedOrganization, "setting.has_telegram_bot") ===
                    1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "single_waiter_on_table",
                  value:
                    get(
                      selectedOrganization,
                      "setting.single_waiter_on_table"
                    ) === 1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_passkey_for_remove_dish",
                  value:
                    get(
                      selectedOrganization,
                      "setting.show_passkey_for_remove_dish"
                    ) === 1,
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "check_language",
                  value: get(
                    selectedOrganization,
                    "setting.check_language",
                    "uz"
                  )
                },
                {
                  name: "check_language_for_kitchener",
                  value: get(
                    selectedOrganization,
                    "setting.check_language_for_kitchener",
                    "uz"
                  )
                },
                {
                  name: "logo_id",
                  value: get(selectedOrganization, "logo"),
                  onSubmitValue: value => (value ? value.id : null)
                },
                {
                  name: "qrcode",
                  value: get(selectedOrganization, "qrcode")
                },
                {
                  name: "employee_phone",
                  value: get(selectedOrganization, "employee_phone")
                },
                {
                  name: "phone",
                  value: get(selectedOrganization, "phone")
                },
                {
                  name: "instagram",
                  value: get(selectedOrganization, "instagram")
                },
                {
                  name: "facebook",
                  value: get(selectedOrganization, "facebook")
                },
                {
                  name: "telegram",
                  value: get(selectedOrganization, "telegram")
                },
                {
                  name: "telegram_bot",
                  value: get(selectedOrganization, "telegram_bot")
                },
                {
                  name: "telegram_channel",
                  value: get(selectedOrganization, "telegram_channel")
                },
                {
                  name: "passkey_for_remove_dish",
                  min: 4,
                  max: 8
                },
                {
                  name: "passkey_for_return_order",
                  min: 4,
                  max: 8
                },
                {
                  name: "passkey_for_change_waiter",
                  min: 4,
                  max: 8
                },
                {
                  name: "passkey_for_return_order_item",
                  min: 4,
                  max: 8
                },
                {
                  name: "start_of_the_day",
                  required: true,
                  value: get(
                    selectedOrganization,
                    "setting.start_of_the_day",
                    "05:00"
                  )
                },
                {
                  name: "delivery_price",
                  value: get(
                    selectedOrganization,
                    "setting.delivery_price",
                    ""
                  )
                },
                {
                  name: "org_name_for_print",
                  value: get(
                    selectedOrganization,
                    "setting.org_name_for_print",
                    ""
                  )
                },
                {
                  name: "comment_for_check",
                  value: get(
                    selectedOrganization,
                    "setting.comment_for_check",
                    ""
                  )
                },
                {
                  name: "telegram_chat_id",
                  value: get(
                    selectedOrganization,
                    "setting.telegram_chat_id",
                    ""
                  )
                },
                {
                  name: "telegram_bot_token",
                  value: get(
                    selectedOrganization,
                    "setting.telegram_bot_token",
                    ""
                  )
                },
                {
                  name: "telegram_info_text",
                  value: get(
                    selectedOrganization,
                    "setting.telegram_info_text",
                    ""
                  )
                },
                {
                  name: "address",
                  value: get(selectedOrganization, "setting.address", "")
                },
                {
                  name: "tax",
                  value: get(selectedOrganization, "setting.tax", "")
                },
                {
                  name: "virtual_cash_register_ip_address",
                  value: get(
                    selectedOrganization,
                    "setting.virtual_cash_register_ip_address",
                    ""
                  )
                },
                {
                  name: "virtual_cash_register_number",
                  value: get(
                    selectedOrganization,
                    "setting.virtual_cash_register_number",
                    ""
                  )
                },
                {
                  name: "tax_fields_units",
                  onSubmitKey: "tax_fields.units",
                  value: get(selectedOrganization, "setting.tax_fields_units", "")
                },
                {
                  name: "tax_fields_vatPercent",
                  onSubmitKey: "tax_fields.vatPercent",
                  value: get(selectedOrganization, "setting.tax_fields_vatPercent", "")
                },
                {
                  name: "tax_fields_ownerType",
                  onSubmitKey: "tax_fields.ownerType",
                  value: get(selectedOrganization, "setting.tax_fields_ownerType", "")
                },
                {
                  name: "tax_fields_packageCode",
                  onSubmitKey: "tax_fields.packageCode",
                  value: get(selectedOrganization, "setting.tax_fields_packageCode", "")
                },
                {
                  name: "tax_fields_spic",
                  onSubmitKey: "tax_fields.spic",
                  value: get(selectedOrganization, "setting.tax_fields_spic", "")
                },
                {
                  name: "kitchener_check_size",
                  value: get(
                    selectedOrganization,
                    "setting.kitchener_check_size",
                    0
                  )
                },
                {
                  name: "latitude",
                  value: get(selectedOrganization, "latitude")
                    ? get(selectedOrganization, "latitude")
                    : "41.3137234",
                  onSubmitValue: value => value && String(value)
                },
                {
                  name: "longitude",
                  value: get(selectedOrganization, "longitude")
                    ? get(selectedOrganization, "longitude")
                    : "69.2396271",
                  onSubmitValue: value => value && String(value)
                },
                {
                  name: "working_times",
                  value: get(selectedOrganization, "working_times")
                },
                {
                  name: "short_description",
                  value: get(selectedOrganization, "short_description")
                },
                {
                  name: "qr_show",
                  value: get(selectedOrganization, "qr_show"),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "order_number_check_size",
                  value: get(
                    selectedOrganization,
                    "setting.order_number_check_size",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "order_unite",
                  value: get(
                    selectedOrganization,
                    "setting.order_unite",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "order_good_unite",
                  value: get(
                    selectedOrganization,
                    "setting.order_good_unite",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "multiple_orders_on_table",
                  value: get(
                    selectedOrganization,
                    "setting.multiple_orders_on_table",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "hide_kitchener_check_sum",
                  value: get(
                    selectedOrganization,
                    "setting.hide_kitchener_check_sum",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "auto_print_receipt_after_payment ",
                  value: get(
                    selectedOrganization,
                    "setting.auto_print_receipt_after_payment ",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_dish_cooking_time",
                  value: get(
                    selectedOrganization,
                    "setting.show_dish_cooking_time",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "custom_total_sum_enabled",
                  value: get(
                    selectedOrganization,
                    "setting.custom_total_sum_enabled",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "custom_percentage_select_enabled",
                  value: get(
                    selectedOrganization,
                    "setting.custom_percentage_select_enabled",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "can_sell_for_debt",
                  value: get(
                    selectedOrganization,
                    "setting.can_sell_for_debt",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_photo",
                  value: get(
                    selectedOrganization,
                    "setting.show_photo",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_waiter_order_history",
                  value: get(
                    selectedOrganization,
                    "setting.show_waiter_order_history",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "can_print_pre_check",
                  value: get(
                    selectedOrganization,
                    "setting.can_print_pre_check",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "auto_create_sms_distribution",
                  value: get(
                    selectedOrganization,
                    "setting.auto_create_sms_distribution",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "auto_transfer_cash_to_safe",
                  value: get(
                    selectedOrganization,
                    "setting.auto_transfer_cash_to_safe",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "has_rfid",
                  value: get(selectedOrganization, "setting.has_rfid", false),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_passkey_for_change_waiter",
                  value: get(
                    selectedOrganization,
                    "setting.show_passkey_for_change_waiter",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "storage_enabled",
                  value: get(
                    selectedOrganization,
                    "setting.storage_enabled",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "stock_control",
                  value: get(
                    selectedOrganization,
                    "setting.stock_control",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_passkey_for_return_order",
                  value: get(
                    selectedOrganization,
                    "setting.show_passkey_for_return_order",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "show_passkey_for_return_order_item",
                  value: get(
                    selectedOrganization,
                    "setting.show_passkey_for_return_order_item",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "min_price_control",
                  value: get(
                    selectedOrganization,
                    "setting.min_price_control",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "allow_custom_price",
                  value: get(
                    selectedOrganization,
                    "setting.allow_custom_price",
                    false
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "add_comment_remove_dish",
                  value: get(
                    selectedOrganization,
                    "setting.add_comment_remove_dish",
                    true
                  ),
                  onSubmitValue: value => (value ? 1 : 0)
                },
                {
                  name: "discounts",
                  value: get(selectedOrganization, "discounts", [])
                }
              ]}
            >
              {({ isSubmitting, values, setFieldValue, errors }) => {
                return (
                  <div>
                    <CustomModal
                      size={500}
                      backdrop="false"
                      isOpen={importModal}
                      toggle={() => showImportModal(false)}
                    >
                      <ImportModal {...{ showImportModal }} />
                    </CustomModal>
                    <div className="px-5 relative">
                      <div className="flex items-center justify-between | mb-24 sticky top-20 bg-white z-50 p-5 pl-[0]">
                        <div className="text-[20px] font-bold">
                          {tr(
                            get(menuItems.find(m => m.id === activeSettingsMenu), "label", "")
                          )}
                        </div>

                        <div className="flex items-center gap-5">
                          <button
                            type="button"
                            size="large"
                            className="d-btn !text-base"
                          >
                            {tr("Отменить")}
                          </button>
                          <button
                            size="large"
                            type="submit"
                            className={`d-btn--full d-btn  d-btn-primary !bg-[#002266] ${isSubmitting ? "--loading" : ""
                              }`}
                            disabled={isSubmitting}
                          >
                            {tr("Сохранить")}
                          </button>
                        </div>
                      </div>

                      {activeSettingsMenu === "main_data_settings" ? (
                        <BasicData
                          {...{ isSubmitting, values, setFieldValue, showClearDataModal }}
                        />
                      ) : null}

                      {activeSettingsMenu === "main_settings" ? (
                        <BasicSettings {...{ isSubmitting, values, setFieldValue }} />
                      ) : null}

                      {activeSettingsMenu === "cheque_settings" ? (
                        <ChequeSettings {...{ isSubmitting, values, setFieldValue }} />
                      ) : null}

                      {activeSettingsMenu === "other_settings" ? (
                        <OtherSettings {...{ isSubmitting, values, setFieldValue }} />
                      ) : null}

                      {activeSettingsMenu === "cheque_constructor" ? (
                        <Navigate to="/settings/cheque-builder" replace />
                      ) : null}

                      {activeSettingsMenu === "tax_parameters" ? (
                        <TaxParameters {...{ isSubmitting, values, setFieldValue }} />
                      ) : null}

                      {activeSettingsMenu === "telegram_settings" ? (
                        <TelegramSettings {...{ isSubmitting, values, setFieldValue }} />
                      ) : null}

                    </div>
                  </div>
                );
              }}
            </EntityForm.Default>
          </div>
        </div>
      </>

      <Modal
        size={600}
        isOpen={clearDataModal}
        toggle={() => showClearDataModal(false)}
        closeIcon={false}
      >
        <div className="modal-body">
          <div className="d-flex align-items-start">
            <img
              src={QuestionCircle}
              alt=""
              width={25}
              height={25}
              className="mr-15"
            />
            <div>
              <span className="fw-600 lh-24 mb-5">
                {tr("Вы точно хотите очистить все отчеты")}
              </span>
              <span className="--danger-color fw-600 ml-5">
                {tr("Нельзя будет отменить")}
              </span>
              <DeleteReports showClearDataModal={showClearDataModal} />

              {/* <div className="mt-20 fs-14">
								<div className="fw-600 lh-24 mb-5">{tr("Будеть очищены")}:</div>
								<div className="">- {tr("Расход товаров")}</div>
								<div className="">- {tr("Приход товаров")}</div>
								<div className="">- {tr("Перемешение товаров")}</div>
								<div className="">- {tr("Возврать товаров")}</div>
								<div className="">- {tr("Инвентаризация товаров")}</div>
								<div className="">- {tr("Отсаток товаров")}</div>
								<div className="">- {tr("Заказы")}</div>
								<div className="">- {tr("Транзакции")}</div>
								<div className="">- {tr("Все отчеты")}</div>
							</div>

							<div className="form-field form-field--small mt-20">
								<input
									onChange={e => setPassword(e.target.value)}
									value={password}
									placeholder={tr("Введите пароль аккаунта")}
									type="password"
									defaultValue={""}
									className="form-field__input"
								/>
							</div>

							<button
								disabled={isSubmitting}
								onClick={clearDataAction}
								className={`d-btn d-btn-primary d-btn--small ${
									isSubmitting ? "--loading" : ""
								}`}
							>
								{tr("Потвердеть")}
							</button> */}
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        size={400}
        isOpen={removeModal}
        toggle={() => showRemoveModal(false)}
        closeIcon={false}
      >
        <div className="modal-body">
          <div className="d-flex align-items-start">
            <img
              src={QuestionCircle}
              alt=""
              width={25}
              height={25}
              className="mr-15"
            />
            <div>
              <span className="fw-600 lh-24 mb-5">
                {tr("Вы точно хотите очистить весь склад?")}
              </span>
              <span className="--danger-color fw-600 ml-5">
                {tr("Нельзя будет отменить")}
              </span>

              <div className="form-field form-field--small mt-20">
                <input
                  onChange={e => setPassword(e.target.value)}
                  value={password}
                  placeholder={tr("Введите пароль аккаунта")}
                  type="password"
                  defaultValue={""}
                  className="form-field__input"
                />
              </div>

              <button
                disabled={isSubmitting}
                onClick={removeAction}
                className={`d-btn d-btn-primary d-btn--small ${isSubmitting ? "--loading" : ""
                  }`}
              >
                {tr("Подтвердить")}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
